import { render, staticRenderFns } from "./ManageMetrics.vue?vue&type=template&id=1d58e314&lang=pug&"
import script from "./ManageMetrics.vue?vue&type=script&lang=js&"
export * from "./ManageMetrics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports